// Получает класс выравнивания по вертикали внешнего контента (prependOuter, appendOuter)
export const getOuterVerticalAlign = (hasLabel: boolean) => {
  // Если есть label - отступ по высоте с учетом высоты label, иначе учитывается высота input
  return hasLabel ? 'e-input__addon--align-by-label' : 'e-input__addon--align-by-input';
};

export const setInputValue = (inputElement: HTMLInputElement, inputValue: string) => {
  const prototype = Object.getPrototypeOf(inputElement);
  const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');

  if (descriptor?.set) descriptor.set.call(inputElement, inputValue);
};

export const emitChangeEvent = (inputElement: HTMLInputElement) => {
  const event = new Event('change', { bubbles: true });
  inputElement.dispatchEvent(event);
};
